import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import { IoMdAlert, IoMdCheckmarkCircleOutline, IoMdDocument } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import { TbDeviceCctv } from "react-icons/tb";
import { FaGun, FaPeopleGroup } from "react-icons/fa6";
import { MdCorporateFare } from "react-icons/md";


export default function ServicesBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh(); // optional: refresh if content changes dynamically
  }, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-background"
				style={{
					paddingBottom: "50px",
				}}
			>
				<div 
					className="container"
					
				>
					
					<div className="row">

						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								OUR SERVICES
							</h6>
							<h6
								className="text-dim pb-5 text-center"
							>
								Our focus is on environmental protection and climate change advocacy, women and youth empowerment, and sustainable agriculture.
							</h6>
						</div>

						<OneService
							image={banner1}
							title="ENVIRONMENTAL PROTECTION"
							description="We work towards creating a sustainable future by advocating for policies and practices that promote environmental protection and reduce climate change impacts."
							navToLink={{
								item: "services",
								subItem: "environments"
							}}
						/>

						<OneService
							image={banner2}
							title="WOMEN AND YOUTH EMPOWERMENT"
							description="We empower women and youth by providing them with the necessary skills, knowledge, and resources to achieve economic and social development."
							navToLink={{
								item: "services",
								subItem: "empowerment"
							}}
						/>

						<OneService
							image={banner3}
							title="SUSTAINABLE AGRICULTURE"
							description="We promote sustainable agriculture practices that empower farmers, increase productivity, and protect the environment. We also quip communities with the necessary tools and knowledge to sustainably manage their resources and support their economic development"
							navToLink={{
								item: "services",
								subItem: "agriculture"
							}}
						/>

						<OneService
							image={banner4}
							title="SOCIAL INCLUSION"
							description="We work with marginalized communities to promote social inclusion, gender equality, and ensure that everyone has equal access to resources and opportunities."
							navToLink={{
								item: "services",
								subItem: "social"
							}}
						/>

						<OneService
							image={banner5}
							title="SUSTAINABLE LIVELIHOODS"
							description="We work with communities to identify the barriers that prevent them from achieving sustainable livelihoods."
							navToLink={{
								item: "services",
								subItem: "livelihoods"
							}}
						/>

						<OneService
							image={banner6}
							title="GOOD GOVERNANCE"
							description="We advocate for good governance practices and work with communities to promote transparency, accountability, and civic engagement."
							navToLink={{
								item: "services",
								subItem: "governance"
							}}
						/>


					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
